import { render, staticRenderFns } from "./LangChooser.vue?vue&type=template&id=d3ffd986&"
import script from "./LangChooser.vue?vue&type=script&lang=js&"
export * from "./LangChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports